<template>
    <div>
        <b-overlay :show="isBusy">
            <AlertDismiss ref="alert" />
            <b-table :busy="isBusy" :fields="fields" :items="items" sticky-header responsive no-border-collapse
                show-empty>
                <template #empty>
                    <b-card class="text-center my-2 fs-5">
                        Aún no se ha agregado ningún comentario
                    </b-card>
                </template>

                <!--icono de carque de tabla-->
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando datos de tabla...</strong>
                    </div>
                </template>
            </b-table>
        </b-overlay>

        <form v-permission="'reuniones-comentarios-vista-crear'" @submit.prevent="onSubmitComment">
            <div class="form-group mb-3">
                <label for="name">Nuevo Comentario</label>
                <textarea class="form-control" id="name" v-model="comment">Escriba su comentario aquí</textarea>
            </div>
            <button type="submit" class="btn btn-primary" :disabled="!comment || isUploadingForm">
                <b-spinner small v-if="isUploadingForm"></b-spinner>
                <b-icon v-else icon="plus" small/>
                Añadir
            </button>
        </form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { formatDateTime } from '@/plugins/complianceScripts/index.js'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';

export default {
    name: 'MeetingComments',

    components: {
        AlertDismiss
    },

    props: {
        meetingId: String
    },

    data() {
        return {
            isBusy: false,
            isUploadingForm: false,
            comment: null,
            denunciationId: null,

            fields: [
                { key: 'comment', label: 'Comentario' },
                { key: 'author', label: 'Creado por' },
                { key: 'creationDate', label: 'Fecha de creación', formatter: formatDateTime },
            ],
            items: [],
        }
    },

    methods: {
        ...mapActions(["allCommentsMeeting", "addCommentMeeting"]),

        async onSubmitComment() {
            this.isUploadingForm = true;
            let result = await this.addCommentMeeting({
                meetingId: this.meetingId,
                comment: this.comment
            })

            if (result.isError) {
                this.$refs.alert.showAlert(result.message, 'danger');
                this.isUploadingForm = false;
                return;
            }

            this.$refs.alert.showAlert('Comentario agregado correctamente', 'success');
            await this.getAll();
            this.comment = null;
            this.isUploadingForm = false;
        },

        async getAll() {
            this.cargandoTabla();
            let result = await this.allCommentsMeeting({ meetingId: this.meetingId });

            if (result.isError) {
                this.$refs.alert.showAlert(result.message, 'danger');
                this.cargandoTabla();
                return;
            }

            this.items = result.data;
            this.cargandoTabla();
        },

        cargandoTabla() {
            this.isBusy = !this.isBusy;
        },
    },

    watch: {
        meetingId: {
            immediate: true,
            async handler(newVal) {
                this.items = [];
                if (newVal === null) {
                    return;
                }
                await this.getAll();
            }
        }
    }
}
</script>
